import { Button, Input, message } from 'antd';
import { history } from '../appRedux/store';
import IntlMessages from "util/IntlMessages";
import React, {useState} from 'react';
import { resetPasswordAPI } from '../services/users-service'


const ResetPassword = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleResetPassword = async() => {
    const url = window.location.href
    const token = new URLSearchParams(url.split('?')[1]).get('token');
    console.log('token', token);

    const response = await resetPasswordAPI({email,password,token})

    if(response.success){
      message.success('Password is reset successfully')
      history.push('/');
      
    } else{
      message.error('Opps! Something went wrong')
    }
  }

  const handleChange = (evt) => {
    setEmail(evt.target.value)
  }

  const handlePasswordChange = (evt) => {
    setPassword(evt.target.value)
  }
  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-logo">
        <img alt="example" src={require("assets/images/clarity-logo.png")} />
      </div>
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
            <div className="gx-app-login-content">
                <h1><IntlMessages id="app.userAuth.resetPassword" /></h1>
                <p><IntlMessages id="app.userAuth.reset" /></p>
                {/* <p><IntlMessages id="app.userAuth.getAccount" /></p> */}
                <Input placeholder='Enter email' type='email' onChange={handleChange}></Input>
                <Input style={{marginTop:'8px'}} placeholder='Enter password' type='password' onChange={handlePasswordChange}></Input>

                <div style={{marginTop:'20px'}}>
                  <Button type='primary' onClick={handleResetPassword}>Send</Button>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword